module.exports = __webpack_public_path__ + "img/exel-btn.97ea2424.svg";